import { extractAlt, extractProperty } from "utils"

import QuoteWithImage from "./QuoteWithImage"

type Props = {
  data: any
}

function QuoteWrapper({ data }: Props) {
  const body = extractProperty(data, "body")
  const image = extractProperty(data, "image")
  const alt = extractProperty(data, "altTextForImage") || extractAlt(data, "image") || ""
  return (
    <QuoteWithImage image={{ url: image, alt }} texts={[body]} />
  )
}

export default QuoteWrapper
